import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconDiamond = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.9047 3.65169L20.9758 10.7228C21.8545 11.6014 21.8545 13.0261 20.9758 13.9047L13.9047 20.9758C13.0261 21.8545 11.6014 21.8545 10.7228 20.9758L3.65169 13.9047C2.77301 13.0261 2.77301 11.6014 3.65169 10.7228L10.7228 3.65169C11.6014 2.77301 13.0261 2.77301 13.9047 3.65169Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export { SvgIconDiamond as ReactComponent };
